import { createSharedComposable } from "@vueuse/core"
import { type AnalyticsCallOptions, type CustomParams, logEvent as logEventFirebase, setUserProperties as setUserPropertiesFirebase } from "firebase/analytics"
import { inject } from "vue"
import { snakeCase } from "~/lib/case"
import { analyticsKey } from "~/plugins/analytics"

type EventParams = { [key: string]: any }

export const useAnalytics = createSharedComposable(() => {
    const analytics = inject(analyticsKey, undefined)
    
    function logEvent(name: string, params?: EventParams) {
        const formattedName = snakeCase(name)
        const formattedParams: EventParams = {}
        for (const key of Object.keys(params || {})) {
            formattedParams[snakeCase(key)] = (params || {})[key]
        }
        if (analytics) {
            logEventFirebase(
                analytics,
                formattedName,
                formattedParams
            )
        }
    }

    function setUserProperties(properties: CustomParams, options?: AnalyticsCallOptions) {
        if (analytics) {
            setUserPropertiesFirebase(analytics, properties, options)
        }
    }
    
    return {
        logEvent,
        setUserProperties
    }
})
